<div class="main-interface" style="flex-direction: column;" data-cy="scheduler-main-container">
  <div class="scheduler-header" data-cy="scheduler-header-section">
    <app-scheduler-view-options style="flex-basis: 250px;"
      (viewTypeChange)="onViewTypeChange($event)"
    data-cy="scheduler-view-options"></app-scheduler-view-options>
    <div style="flex-basis: 1px; background-color: var(--tdo-primary); opacity: 0.2;"></div>
    <div style="flex-basis: 320px;" data-cy="scheduler-calendar-section">
      <app-tdo-mini-calendar #calendar [isGetAppointmentDays]="true"
        (selectedDateChange)="onSelectedDateChange($event)"
      data-cy="scheduler-mini-calendar"></app-tdo-mini-calendar>
    </div>
    <!--<div style="flex-basis: 640px;" *ngIf="viewType === 'dayDetailView'">
  </div>-->
  <div style="flex-basis: 1px; background-color: var(--tdo-primary); opacity: 0.2;"></div>
  <div style="flex-basis: 500px; flex-grow: 1;" data-cy="scheduler-operatory-section">
    @if (viewType !== 'dayDetailView') {
      <app-scheduler-operatory-selector
        (operatoriesSelected)="onOperatoriesSelected($event)"
        (locationsOpsChanged)="onLocationsOrOpsChanged($event)"
        (locationsSelected)="onLocationsSelected($event)"
        data-cy="scheduler-operatory-selector">
      </app-scheduler-operatory-selector>
    }
    @if (viewType == 'dayDetailView') {
      <div style="width: 100%; height: 100%; padding: 6px;" data-cy="scheduler-doctor-selector-section">
        <div style="color: var(--tdo-secondary);" data-cy="scheduler-doctor-label">Doctor</div>
        <div style="width: 100%;" data-cy="scheduler-doctor-dropdown-container">
          @if (providerDocs) {
            <tdo-dropdown-v2 [isMultiSelect]="true" [isIncludeAll]="true" [isAutoSelectAll]="true"
              [displayPredicate]="doctorPredicate" widthString="100%"
              [datasource]="providerDocs" (closed)="onDocListClosed($event)"
              (selectionChange)="onDocListChanged($event)"
            data-cy="scheduler-doctor-dropdown"></tdo-dropdown-v2>
          }
        </div>
      </div>
    }
  </div>
  @if (showWaitList || isReferralAppointment || isReschedule) {
    <div
      style="height: 100%; overflow-y: auto; margin-right: 5px; width: 150px"
      data-cy="scheduler-additional-options-section">
      @if (showWaitList) {
        <div class="scheduler-view-options-list-item" data-cy="scheduler-waitlist-item">
          <div class="list-item-pill" (click)="onOpenWaitListComponent()" data-cy="scheduler-waitlist-button">
            <div style="flex: 1; padding-left: 5px; text-align: left;" data-cy="scheduler-waitlist-label">Wait List</div>
          </div>
        </div>
      }
      @if (isReschedule) {
        <div data-cy="scheduler-reschedule-item">
          <div class="list-item-pill-warning" [matTooltip]="getRescheduleTooltipText()"
            matTooltipPosition="below" matTooltipClass="multiline-tooltip"
            data-cy="scheduler-reschedule-button">
            <div style="flex: 1; padding-left: 5px; text-align: left;" data-cy="scheduler-reschedule-label">Paste Reschedule</div>
          </div>
        </div>
      }
      @if (isReferralAppointment) {
        <div class="scheduler-view-options-list-item" data-cy="scheduler-referral-item">
          <div class="list-item-pill" #tooltip2="matTooltip" [matTooltip]="getReferralTooltipText()"
            matTooltipPosition="below" matTooltipClass="multiline-tooltip"
            (contextmenu)="$event.preventDefault(); onRowContextMenu($event)"
            data-cy="scheduler-referral-button">
            <div style="flex: 1; padding-left: 5px; text-align: left;" data-cy="scheduler-referral-label">Referral</div>
          </div>
        </div>
      }
    </div>
  }
</div>
@if (viewType !== 'dayDetailView') {
  <div style="flex-basis: 20px; display: flex; margin-left: var(--margin-size);" data-cy="scheduler-location-tabs">
    @for (loc of selectedLocations; track loc) {
      <div (click)="onLocationTabSelected(loc)" class="scheduler-tab-item"
        [ngClass]="{'scheduler-tab-item-selected': isSelectedLocationTab(loc)}"
      data-cy="scheduler-location-tab-item">{{loc.Name}}</div>
    }
  </div>
}
@if (viewType !== 'dayDetailView') {
  <div class="scheduler-content" data-cy="scheduler-content-container">
    @if (!currentLocation) {
      <div class="missing-data-message" data-cy="scheduler-missing-location-message"> Please select a Location from the available list.</div>
    }
    @if (currentLocation && currentLocationOperatoryData.length==0) {
      <div class="missing-data-message" data-cy="scheduler-missing-operatory-message"> Please select
        an Operatory from the available list.
      </div>
    }
    @if (viewType !== 'dayDetailView') {
      <div style="flex-basis: 5px; background-color: white;"></div>
    }
    <div style="flex: 1; overflow: hidden; margin-top: 1px;" data-cy="scheduler-appointments-container">
      @if (viewType !== 'dayDetailView' && currentLocation && currentLocationOperatoryData.length>0) {
        <app-scheduling style="width: 100%; height: 100%;"
          #scheduling [tdoCurrentDate]="selectedDate" [operatoryDataModels]="currentLocationOperatoryData"
          (appointmentDialogDataForWaitList)="receiveObject($event)" [viewType]="viewType"
        data-cy="scheduler-appointments-grid"></app-scheduling>
      }
    </div>
  </div>
}
@if (viewType === 'dayDetailView') {
  <div
    style="flex: 1; margin: 0 var(--margin-size) var(--margin-size) var(--margin-size);"
    data-cy="scheduler-day-detail-container">
    @if (viewType === 'dayDetailView' && selectedDocs && selectedDocs.length > 0) {
      <app-day-detail-view #detailView [selectedDoctors]="selectedDocs" [selectedDate]="selectedDate"
        style="display: flex; flex: 1; width: 100%; height: 100%; overflow-y: hidden;"
      data-cy="scheduler-day-detail-view"></app-day-detail-view>
    }
  </div>
}
</div>


